import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useParams } from "react-router-dom";
import { getBlogsView, listBlogs } from "../../server/apihelper"; // Blog API helper
import { format } from "date-fns";

export const BlogDetails = () => {
  const [blogView, setBlogView] = useState(null);
  const [blogList, setBlogList] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    AOS.init();
  }, []);

  // Fetch single blog details
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await getBlogsView(id);
        setBlogView(res.data);
      } catch (error) {
        console.error("Error fetching blog:", error);
      }
    };
    fetchBlog();
  }, [id]);

  // Fetch latest blogs for sidebar
  useEffect(() => {
    const query = "page=1&items_per_page=10";
    listBlogs(query).then((res) => {
      setBlogList(res.data);
    });
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "Invalid Date";
    try {
      return format(new Date(dateString), "EEEE do MMMM");
    } catch (error) {
      console.error("Date parsing error:", error);
      return "Invalid Date";
    }
  };

  return (
    <>
      {/* Page Banner */}
      <div className="page-banner-area bg-1">
        <div className="container">
          <div className="page-banner-content">
            <h1>Blog Details</h1>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li className="navspace"><Link to="/blogs">Blogs</Link></li>
              <li className="navspace">Blog Details</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Blog Details Section */}
      <div className="campus-life-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            {blogView ? (
              <div className="col-lg-8">
                <div className="single-blog-details">
                  <img src={blogView.image} alt={blogView.title} width={1200} height={800} />
                  <h2>{blogView.title}</h2>
                  <p className="date-author">
                    {formatDate(blogView.date)} | {blogView.author || "Admin"}
                  </p>
                  <p className="text-justify">{blogView.description}</p>
                </div>
              </div>
            ) : (
              <span>No Blog Data</span>
            )}

            <div className="col-lg-4">
              <div className="trending">
                <h3>Latest Blogs</h3>
                {blogList.map((item, index) => (
                  <div className="trending-box" key={index}>
                    <div className="trending-content">
                      <Link to={`/blog-details/${item.primaryId}`}>
                        <img src={item.image} alt={item.title} width={420} height={280} />
                      </Link>
                      <h4>
                        <Link
                          to={`/blog-details/${item.primaryId}`}
                          className={item.title === blogView?.title ? "active-title" : ""}
                        >
                          {item.title}
                        </Link>
                      </h4>
                      <Link
                        to={`/blog-details/${item.primaryId}`}
                        className={
                          item.title === blogView?.title
                            ? "active-title1"
                            : "inactive-title1"
                        }
                      >
                        {item.description.split(" ").slice(0, 5).join(" ")}...
                      </Link>
                      <Link
                        to={`/blog-details/${item.primaryId}`}
                        className="read-more-btn"
                      >
                        Read More<i className="flaticon-next"></i>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};
